import React from 'react';
import { Button } from './ui/Button';
import { ArrowLeftIcon } from 'lucide-react';
export function Privacy() {
  return <section className="py-16 bg-white" data-id="element-385">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-386">
        <div className="max-w-4xl mx-auto" data-id="element-387">
          <div className="mb-10 flex items-center" data-id="element-388">
            <Button variant="ghost" className="mr-4" href="/" data-id="element-389">
              <ArrowLeftIcon className="mr-2" size={16} data-id="element-390" />
              Back to home
            </Button>
          </div>
          <div className="border-2 border-[#00A862] rounded-xl p-8 shadow-md bg-white" data-id="element-391">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-392">
              Nexio App Privacy Statement
            </h1>
            <div className="bg-gray-50 px-4 py-2 rounded-lg inline-block mb-6" data-id="element-393">
              <p className="text-gray-600" data-id="element-394">Effective Date: 1-10-2025</p>
            </div>
            <div className="prose max-w-none text-gray-700" data-id="element-395">
              <p className="mb-6" data-id="element-396">
                At Nexio App, we value your privacy and are committed to
                protecting your personal data. This Privacy Statement explains
                what information we collect, how we use it, and your rights
                regarding your data.
              </p>
              <h2 className="text-xl font-bold text-[#00A862] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-397">
                1. Information We Collect
              </h2>
              <p className="mb-4" data-id="element-398">
                We may collect the following types of information:
              </p>
              <ul className="space-y-2 mb-6" data-id="element-399">
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-400">
                  <span className="font-medium" data-id="element-401">Account Information:</span>{' '}
                  Name, email address, password, company details (if
                  applicable).
                </li>
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-402">
                  <span className="font-medium" data-id="element-403">Usage Data:</span> Interactions
                  with the app, log data, IP address, device information,
                  browser type.
                </li>
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-404">
                  <span className="font-medium" data-id="element-405">Payment Information:</span>{' '}
                  Billing details and payment method (processed securely by
                  third-party providers; we do not store full credit card
                  information).
                </li>
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-406">
                  <span className="font-medium" data-id="element-407">
                    Support & Communication Data:
                  </span>{' '}
                  Messages, emails, or other interactions with our team.
                </li>
              </ul>
              <h2 className="text-xl font-bold text-[#00A862] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-408">
                2. How We Use Your Information
              </h2>
              <p className="mb-4" data-id="element-409">We use your data to:</p>
              <ul className="space-y-2 mb-6" data-id="element-410">
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-411">
                  Provide and improve Nexio App's services
                </li>
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-412">
                  Process payments and manage subscriptions
                </li>
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-413">
                  Personalize your user experience
                </li>
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-414">
                  Communicate updates, service announcements, or support
                  messages
                </li>
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-415">
                  Ensure security, prevent fraud, and comply with legal
                  obligations
                </li>
              </ul>
              <h2 className="text-xl font-bold text-[#00A862] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-416">
                3. Sharing of Information
              </h2>
              <p className="mb-4" data-id="element-417">We only share your personal data with:</p>
              <ul className="space-y-2 mb-6" data-id="element-418">
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-419">
                  Service Providers (e.g., payment processors, hosting services)
                  who help operate Nexio App
                </li>
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-420">
                  Legal Authorities if required by law or to protect our rights
                  and users' safety
                </li>
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-421">
                  We do not sell, rent, or trade your personal data to third
                  parties
                </li>
              </ul>
              <h2 className="text-xl font-bold text-[#00A862] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-422">
                4. Data Retention
              </h2>
              <p className="mb-6" data-id="element-423">
                We keep your personal data only as long as necessary to provide
                our services and meet legal obligations. You can request
                deletion of your account at any time.
              </p>
              <h2 className="text-xl font-bold text-[#00A862] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-424">
                5. Security
              </h2>
              <p className="mb-6" data-id="element-425">
                We implement appropriate technical and organizational measures
                to protect your data against unauthorized access, alteration,
                disclosure, or destruction.
              </p>
              <h2 className="text-xl font-bold text-[#00A862] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-426">
                6. Your Rights
              </h2>
              <p className="mb-4" data-id="element-427">
                Depending on your location, you may have the right to:
              </p>
              <ul className="space-y-2 mb-6" data-id="element-428">
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-429">
                  Access, update, or delete your personal data
                </li>
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-430">
                  Request a copy of your data in a portable format
                </li>
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-431">
                  Withdraw consent for certain data uses
                </li>
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-432">
                  File a complaint with your local data protection authority
                </li>
              </ul>
              <p className="mb-6" data-id="element-433">
                To exercise your rights, contact us at:{' '}
                <span className="text-[#00A862] font-medium" data-id="element-434">
                  info@nexioapp.cloud
                </span>
              </p>
              <h2 className="text-xl font-bold text-[#00A862] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-435">
                7. Cookies & Tracking
              </h2>
              <p className="mb-6" data-id="element-436">
                Nexio App uses cookies and similar technologies to enhance your
                experience, analyze usage, and provide relevant content. You can
                manage or disable cookies in your browser settings.
              </p>
              <h2 className="text-xl font-bold text-[#00A862] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-437">
                8. Changes to this Privacy Statement
              </h2>
              <p className="mb-6" data-id="element-438">
                We may update this Privacy Statement from time to time. The
                latest version will always be available on our website.
              </p>
              <h2 className="text-xl font-bold text-[#00A862] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-439">
                9. Contact Us
              </h2>
              <p className="mb-6" data-id="element-440">
                If you have questions or concerns about this Privacy Statement,
                please contact us at:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-100 shadow-sm" data-id="element-441">
                <p className="flex items-center justify-center space-x-4" data-id="element-442">
                  <span data-id="element-443">
                    📧{' '}
                    <a href="mailto:info@nexioapp.cloud" className="text-[#00A862] hover:underline" data-id="element-444">
                      info@nexioapp.cloud
                    </a>
                  </span>
                  <span data-id="element-445">
                    🌐{' '}
                    <a href="https://nexioapp.cloud" className="text-[#00A862] hover:underline" data-id="element-446">
                      nexioapp.cloud
                    </a>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}